import { render, staticRenderFns } from "./letterMat.vue?vue&type=template&id=ffa80502&scoped=true"
import script from "./letterMat.vue?vue&type=script&lang=js"
export * from "./letterMat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa80502",
  null
  
)

export default component.exports